import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/offline.svg'


const _withScopeId = n => (_pushScopeId("data-v-0a126360"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "offline-img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "You’re currently offline", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "You can access this when you’re back online.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "In the meantime, you can", -1))
const _hoisted_6 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_BaseButton, {
        class: "button",
        "new-secondary": "",
        click: _ctx.onClickViewScorecard
      }, {
        default: _withCtx(() => [
          _createTextVNode(" View Scorecard ")
        ], undefined, true),
        _: 1
      }, 8, ["click"]),
      _createVNode(_component_BaseButton, {
        class: "button",
        "new-secondary": "",
        click: _ctx.onClickViewFeedback
      }, {
        default: _withCtx(() => [
          _createTextVNode(" View Feedback ")
        ], undefined, true),
        _: 1
      }, 8, ["click"])
    ])
  ]))
}